import { PropsWithChildren } from 'react';
import styles from '../sass/components/Field.module.scss';

/** The id of a Field's visible label text, for the box's aria-labelledby. */
export const fieldLabelId = (id: string) => `${id}-label`;

/**
 * A labelled row. The box inside must carry `id` (the label's `for` points
 * at it; QA 2026-09-25 #31 found `for="email"` over a box with no id, so
 * nothing was labelled), and should take `labelledBy={fieldLabelId(id)}`:
 * the label element also wraps the box's error text and, for a password,
 * its Show button, which would otherwise be read as part of its name.
 */
export default function Field(
  {
    id,
    label,
    children,
  }: PropsWithChildren<{
    id: string;
    label: string;
  }>,
) {
  return (
    <label htmlFor={id} className={styles.field}>
      <span className={styles.label} id={fieldLabelId(id)}>{label}</span>
      {children}
    </label>
  );
}
